import { ChevronDown, ChevronUp, Trash2 } from 'lucide-react';

import type { ReactNode } from 'react';

export interface RowShellProps {
  index: number;
  total: number;
  disabled?: boolean;
  onMove: (from: number, to: number) => void;
  onRemove: (index: number) => void;
  children: ReactNode;
}

export const RowShell = ({ index, total, disabled, onMove, onRemove, children }: RowShellProps) => (
  <div className="rounded-md border border-zinc-200 bg-zinc-50 p-3">
    <div className="mb-2 flex items-center justify-between">
      <span className="text-xs font-medium text-zinc-500">Item {index + 1}</span>
      {!disabled && (
        <div className="flex items-center gap-2 text-zinc-400">
          <button
            type="button"
            disabled={index === 0}
            onClick={() => onMove(index, index - 1)}
            className="hover:text-zinc-700 disabled:opacity-30"
            aria-label="Move up"
          >
            <ChevronUp className="h-3.5 w-3.5" />
          </button>
          <button
            type="button"
            disabled={index === total - 1}
            onClick={() => onMove(index, index + 1)}
            className="hover:text-zinc-700 disabled:opacity-30"
            aria-label="Move down"
          >
            <ChevronDown className="h-3.5 w-3.5" />
          </button>
          <button
            type="button"
            onClick={() => onRemove(index)}
            className="hover:text-rose-600"
            aria-label="Remove"
          >
            <Trash2 className="h-3.5 w-3.5" />
          </button>
        </div>
      )}
    </div>
    <div className="space-y-2">{children}</div>
  </div>
);

export const AddRowButton = ({
  label,
  onClick,
  disabled,
}: {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}) =>
  disabled ? null : (
    <button
      type="button"
      onClick={onClick}
      className="w-full rounded-md border border-dashed border-zinc-300 py-2 text-xs font-medium text-zinc-500 hover:border-zinc-400 hover:text-zinc-700"
    >
      + {label}
    </button>
  );
